// extracted by mini-css-extract-plugin
export default {"dropdown-option":"pemuj","dropdown-no-options":"shtTF"};